import { REPORT_TEMPLATE, type IReportCardInfo, type TechBgCardData } from '@/types';
import type { BaseCardService } from './abstract-base-card-service';
import { BaseCardServiceImpl, type BaseReportCardData } from './abstract-base-card-service';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ReportApiService } from '@/infrastructure/api-functions/report-api-service';
import { I18nService } from '../i18n-service';
import _ from 'lodash'

export const TechBgService = Symbol('TechBgService');

export type TechBgService = BaseCardService<TechBgCardData>

@injectable()
export class TechBgServiceImpl extends BaseCardServiceImpl<TechBgCardData> implements TechBgService {
    _modelData = {
        isLoading: false,
        isFailed: false,
        isSuccess: false,
        data: undefined,
    };

    templateType = REPORT_TEMPLATE.TECHNICAL_BACKGROUND;

    constructor(
    @inject(ReportApiService) _reportApiService: ReportApiService,
    @inject(I18nService) private readonly _i18nService: I18nService
    ) {
        super(
            _reportApiService
        );
    }

    private _generateTechBgCardData(cardData: BaseReportCardData<IReportCardInfo>) {
        const cardInfo = cardData.data?.[REPORT_TEMPLATE.TECHNICAL_BACKGROUND];
        const desc = cardInfo?.TECHNICAL_BACKGROUND_GPT || this._i18nService.t('report.noData')
        const patentChartData = _.isEmpty(cardInfo?.TECHNICAL_BACKGROUND_PATENT_CHART) ? undefined : cardInfo?.TECHNICAL_BACKGROUND_PATENT_CHART
        const paperChartData = _.isEmpty(cardInfo?.TECHNICAL_BACKGROUND_PAPER_CHART) ? undefined : cardInfo?.TECHNICAL_BACKGROUND_PAPER_CHART

        return {
            description: desc,
            patentChartData,
            paperChartData,
        }
    }

    updateFetchData(getUpdateValue: (v: BaseReportCardData<IReportCardInfo>) => BaseReportCardData<IReportCardInfo>): void {
        const updatedValue = getUpdateValue(_.omit(this.modelData, 'data'));

        const dataHaveFromUpdated = _.has(updatedValue, 'data')

        if (dataHaveFromUpdated) {
            this.update(modelData => ({
                ...modelData,
                ...updatedValue,
                data: this._generateTechBgCardData(updatedValue),
            }));
        } else {
            this.update(m => ({
                ...m,
                ...updatedValue,
                data: m.data,
            }));
        }
    }
}
